import { Component } from 'react';
import AuthModalContext from '../contexts/AuthModalContext';

class AuthRedirect extends Component {
  static contextType = AuthModalContext;

  componentDidMount() {
    const { tab } = this.props;
    this.props.history.replace('/');
    // Small delay to let the route change complete before opening modal
    setTimeout(() => {
      this.context.openAuthModal(tab || 'login');
    }, 0);
  }

  render() {
    return null;
  }
}

export default AuthRedirect;
